import React from "react"
import { Link } from "gatsby"
import Button from "../components/button"

import Layout from "../components/layout"
import SEO from "../components/seo"

const NotFoundPage = () => {
  function notFoundBg() {
    return (
      <div className="not-found">
        <span className="error">{'< Erro 404 />'}</span>
        <h1>Ops<span>!</span></h1>
        <small>Página não Encontrada</small>
        <Link to="/"><Button title='Voltar para home' className='btn-404' /></Link>
      </div>
    )
  }
  return (
    <Layout contentBg={notFoundBg()} layout404='page-404'>
      <SEO title="404: Not found" />
    </Layout>
  )
}

export default NotFoundPage
